export default __webpack_public_path__ + "c8db697f198113c291316827c4bdf51a.png";